const initialState = {
    "paso": 0,
    "correo": "",
    "url":"",
    "flagError": false,
    "errorMsj": "",
}

export function olvideRdc(state = initialState, action) {
    
    switch (action.type) {
        case "OLVIDE_PASO_SIGUIENTE": 
            return {...state,
                "paso": state.paso + 1
            };
        case "OLVIDE_PASO_ANTERIOR":
        	return {...state,
        		"paso": state.paso - 1
        	};
        case "OLVIDE_SET_PASO": 
            return {...state,
                "paso": action.paso
            };
        case "OLVIDE_SET_CORREO":
            return {...state,
                "correo": action.correo
            };
        case "OLVIDE_RESET_PASO":
            return {...state,
                "paso": 0
            };
        case "OLVIDE_SET_URL":
            return {...state,
                "url": action.url
            };
        case "OLVIDE_SET_FLAG_ERROR":
            return {...state,
                "flagError": action.flag
            };
        case "OLVIDE_SET_MENSAJE_ERROR":
            return {...state,
                "errorMsj": action.mensaje
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/olvide/reducer.js